import { useMe } from "@/api/queries";
import { setTimeZone } from "@/lib/format";

/**
 * Every clock on screen shows the business's time zone, the one the server words its sentences
 * in. Returns whether the console knows it yet, so a screen can wait for it.
 */
export function useBusinessZone(): boolean {
  const me = useMe();
  const tz = me.data?.tenant.timezone;
  if (tz) setTimeZone(tz);
  return me.isSuccess || me.isError;
}
